class ValidateFormNotify {
  static getEmailData(dst, user, docs) {
    return getEmailDataFormValidation(dst, user, docs);
  }
}

export default ValidateFormNotify;

const getEmailDataFormValidation = (dst, user, docs) => {
  const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

  const to = dst;
  const subject = `Usuario ${user?.displayName} solicita acceso al Portal`;
  const body = dataFormValidation(user, docs);

  return {
    from,
    to,
    subject,
    body
  };
};

const dataFormValidation = (user, docs) => {
  return `
        <h2 style="text-align: center;">
          Entrega de documentos proceso de registro Portal de Proyectos
        </h2>
        <br />
        <p>Estimado(a) Administrador,</p>
        <br />
        <p>
          Queremos informarte que usuario <strong>${user?.displayName}</strong> ha subido los siguientes documentos al portal:
        </p>
        <br />
          <p> 
            <h3>Documentos cargados y pendientes por verificar:</h3>
            <p><strong>FORMATO 1 - NOMBRAMIENTO DEL REPRESENTANTE INSTITUCIONAL:</strong> <a href="${
              docs?.form1
            }">Descargar y verificar</a></p>
            <p><strong>FORMATO 2 - ACUERDO DE AFILIACIÓN INDIVIDUALIZADO:</strong>  <a href="${docs?.form2}">Descargar y verificar</a></p>
          </p>
          <p> 
            <h3>Datos del usuario.</h3>
            <p><strong>Nombre completo:</strong> ${user?.displayName}</p>
            <p><strong>Dependencia:</strong> ${JSON.parse(user?.reloadUserInfo?.customAttributes).dependence}</p>
            <p><strong>Email:</strong> ${user?.email}</p>
            <p><strong>Telefono de contacto:</strong> ${user?.phoneNumber}</p>
          </p>
        <br />
        <p>
          Revisa tu lista de pendientes y autorizaciones en el Portal <a href="${'https://portal.modernizacion.gob.sv'}">(Enlace)</a>
          Te estaremos informando acerca de mas solicitudes.
        </p>
        <br />
        <p>Saludos,</p>
        <br />
        <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>
      `;
};
